import { Outlet } from 'react-router';
import styled from 'styled-components';
import { useSyncSentryUser } from 'src/utils/sentry/syncUser';

const CommonLayout = styled.div`
  max-width: 430px;
  margin: 0 auto;
`;

const Layout = () => {
  useSyncSentryUser();

  return (
    <CommonLayout>
      <Outlet />
    </CommonLayout>
  );
};

export default Layout;
